import { createAction } from 'redux-actions';

import { USER_ROLES } from 'constants/general';
import user from 'features/views/user';

import * as types from './actionTypes';
import { views } from './constants';

const roleToViewMap = {
	[USER_ROLES.PPZ]: views.PPZ,
	[USER_ROLES.SELLER]: views.SELLER,
	[USER_ROLES.GROUP_MANAGER]: views.MANAGER,
	[USER_ROLES.AGENCY_MANAGER]: views.REGION,
	[USER_ROLES.REGION_MANAGER]: views.REGION,
	[USER_ROLES.DISTRICT_MANAGER]: views.REGION,
	[USER_ROLES.GUARANTOR]: views.REGION,
	[USER_ROLES.CENTRAL]: views.CENTRAL,
};

export const changeView = createAction(types.CHANGE_VIEW);
export const returnToPreviousView = createAction(types.RETURN_TO_PREVIOUS_VIEW);

export const changeViewDependingOnRole =
	(campaignId, redirectedFromPK = false) =>
	(dispatch, getState) => {
		const state = getState();
		const { currentRole, hasKmpSellerSubordinates } = user.selectors.getInfo(state);
		const userLogon = user.selectors.getUser(state);
		const userStructure = user.selectors.getRolesByCurrentRole(state);
		// exception in changing view - only for redirected guarantor, otherwise use default roleToViewMap
		const isGuarantorAndRedirectedFromPK = currentRole === USER_ROLES.GUARANTOR && redirectedFromPK;
		let view;

		if (isGuarantorAndRedirectedFromPK) {
			view = views.OVERVIEW;
		} else {
			view = roleToViewMap[currentRole];
		}

		dispatch(
			changeView({
				campaignId,
				view,
				hasSubordinates: currentRole === USER_ROLES.SELLER ? hasKmpSellerSubordinates : false,
				structures: userStructure
					.filter((structure) =>
						structure.role === USER_ROLES.GUARANTOR ? structure.campaignWaveId === campaignId : true,
					)
					.map((structure) => ({
						channelId: structure.role === USER_ROLES.GUARANTOR ? undefined : structure.channelId,
						regionId: structure.regionId,
						agencyIds: structure.agencyId ? [structure.agencyId] : undefined,
						regionalManager: view === views.REGION ? userLogon : undefined,
						manager: structure.managerLogin,
						seller: structure.sellerLogin,
						ppz: structure.ppzLogin,
					})),
				history: [],
			}),
		);
	};
